import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import { useTranslation } from "react-i18next";
import "./MonitorProjectFilter.css";

export default function MonitorProjectFilter({ prefix, active, onChange, incomplete }) {
  const { t } = useTranslation("monitor");
  return <div className="iio-monitor-project-filter">
    <FormControlLabel
      className="iio-monitor-project-control"
      control={<Switch checked={active} onChange={event => onChange(event.target.checked)}
        inputProps={{ role: "switch", "aria-label": t("projektfilter.aria", { prefix }) }} />}
      label={active ? t("projektfilter.projekt", { prefix }) : t("projektfilter.alle")}
    />
    <span className="iio-monitor-project-explanation">
      {active ? t("projektfilter.hinweis", { prefix }) : t("projektfilter.instanz")}
      {active && incomplete && <span role="status"> {t("projektfilter.unvollstaendig")}</span>}
    </span>
  </div>;
}
